import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/'
import routes from './routes'
import config from '../config'

Vue.use(Router)
config.init()
const router = new Router({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch('auth/authenticate').then((app) => {
      if (to.matched.some(record => record.meta.superUser)) {
        if (store.state.auth.isSuperUser) {
          if(config.isCustomersOnly()){
            next({ path: '/forbidden' })
            return
          }
          store.commit('auth/setCurrentApplicationForSuperuser', null)
          next()
        } else {
          next({ path: '/forbidden' })
        }
      } else {
        let app = store.state.auth.application
        if (store.state.auth.isSuperUser) {
          if(config.isCustomersOnly()){
            next({ path: '/forbidden' })
            return
          }

          if (to.params && to.params.application) {
            // 本番／検証環境の場合、prodで指定したアプリケーションのみ有効
            let stage = ['prod', 'staging'].includes(config.getStage()) ? 'prod' : 'applications'
            let definitions = store.state.auth.definitions['common:application']
            if (definitions && definitions.meaning[stage].some(val => val.code == to.params.application)) {
              store.commit('auth/setCurrentApplicationForSuperuser', to.params.application)
            } else {
              next({ path: '/forbidden' })
            }
          }
          next()

        } else if (to.matched.some(record => !record.meta.checksApplication)) {
          next()

        } else if (to.params && to.params.application === app) {
          next()

        } else {
          next({ path: '/forbidden' })
        }
      }
    }).catch((err) => {
      console.log(err)
      next({ path: '/login', query: { redirect: to.fullPath } })
    })

  } else {
    next()
  }
})

export default router
